import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {ProductFrequency} from '../../../../../api';

interface ProductFrequencyOption {
  id: string;
  name: string;
}

@Component({
  selector: 'elcia-product-frequency-dropdown',
  imports: [Dropdown, TranslatePipe],
  templateUrl: './product-frequency-dropdown.html',
})
export class ProductFrequencyDropdown {
  private readonly translate = inject(TranslateService);
  private readonly langChange = toSignal(this.translate.onLangChange, {initialValue: null});

  control = input.required<FormControl>();

  protected readonly options = computed<ProductFrequencyOption[]>(() => {
    this.langChange();
    return Object.values(ProductFrequency).map(frequency => ({
      id: frequency,
      name: this.translate.instant(`product-frequency.${frequency}`),
    }));
  });
}
